import { useApplicationConfigStore } from '~/store/application-config'
import { storeToRefs } from 'pinia'

export function useNavItem() {
  const applicationConfigStore = useApplicationConfigStore()
  const { navItems, completedModuleEventPaths } = storeToRefs(applicationConfigStore)
  const currentRoute = useRoute()

  const activeRoute = computed(() => {
    const _curPath = currentRoute.path
    const _navItems = navItems?.value

    if (!_navItems) {
      return ''
    }

    return _navItems.reduce((result, route) => {
      // If we already have a result, escape out
      if (result !== '') {
        return result
      }

      // Check for direct match
      if (route.url === _curPath) {
        return route.url
      }

      // Visible children return their own url
      let visibleChildren = route.visibleChildren || []
      for (let child of visibleChildren) {
        if (_curPath === child.url) {
          return child.url
        }
      }

      // Hidden children return the parent's url
      let hiddenChildren = route.hiddenChildren || []
      for (let child of hiddenChildren) {
        if (_curPath === child.url) {
          return route.url
        }
      }

      return '' // Don't forget to return for the reduce to continue!
    }, '')
  })

  const activeParent = computed(() => {
    if (activeRoute.value === '') {
      return ''
    }

    const _curPath = currentRoute.path
    const _navItems = navItems?.value

    return _navItems.reduce((result, route) => {
      // If we already have a result, escape out
      if (result !== '') {
        return result
      }

      let visibleChildren = route.visibleChildren || []
      for (let child of visibleChildren) {
        if (_curPath === child.url) {
          return route.url
        }
      }

      return ''
    }, '')
  })

  function isNavItemComplete(item) {
    if (!item?.visibleChildren?.length && !item?.hiddenChildren?.length) {
      return item.completed
    }

    return item.completed && [...item?.visibleChildren ?? [], ...item?.hiddenChildren ?? []]
      .every(child => {
        // adopted hiddenChildren don't have a completed property
        if(child?.completed === undefined) {
          return true
        }

        return child.completed === true
      })
  }

  function isNavItemCompleteOptimistic(item) {
    if (!item?.url) {
      return false
    }

    if (!item?.visibleChildren?.length && !item?.hiddenChildren?.length) {
      return completedModuleEventPaths.value.includes(item.url)
    }

    const parentComplete = completedModuleEventPaths.value.includes(item.url)

    return parentComplete && [...item?.visibleChildren ?? [], ...item?.hiddenChildren ?? []]
      .every(child => {
        // adopted hiddenChildren don't have a completed property
        if(child?.completed === undefined){
          return true
        }
        return completedModuleEventPaths.value.includes(child?.url)
      })
  }

  return { activeRoute, activeParent, isNavItemComplete, isNavItemCompleteOptimistic }
}
